import * as Yup from 'yup';

export const validationSchema = Yup.object({
  email: Yup.string().nullable(true).email('Neplatná emailová adresa').required('Povinná položka'),
});
